import React from "react";
import ReactDOM from "react-dom/client";
import "./App.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./application/store";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const backend = window.screen.width <= 1366 ? TouchBackend : HTML5Backend;
root.render(
  <DndProvider backend={backend}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </DndProvider>
);

reportWebVitals();
